/* eslint-disable */
export default {
  _Title: 'Title',
  _BG_ITEM_2: 'BG+ITEM+2',
  _LBL_IceCream: 'LBL_IceCream',
  _LBL_Make_A: 'LBL_Make_A',
}